/*
 * @Descripttion: 
 * @version: 1.0
 * @Author: hayuu
 * @Date: 2024-08-26 20:51:12
 * @LastEditors: hayuu
 * @LastEditTime: 2025-03-21 11:39:02
 */
/*
 * @Descripttion: 
 * @version: 1.0
 * @Author: hayuu
 * @Date: 2024-08-26 20:51:12
 * @LastEditors: hayuu
 * @LastEditTime: 2024-10-22 11:26:39
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'

Vue.config.productionTip = false

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// import OpenAI from 'openai'
// const openai = new OpenAI({
//  base_url: "https://api.deepseek.com/v1",
//  apiKey: "sk-16015a5690f64cf3b4c6d20e5f98b11b",
//  dangerouslyAllowBrowser: true
// })
// console.log(openai);
// 引入JS
import '@/api/myApi.js'; // http接口文件
import store from './store';

import VueZzqKeyboard from './packages/index'
Vue.use(VueZzqKeyboard)

Vue.component('login', require('@/components/login.vue').default)
Vue.component('rateDia', require('@/components/rateDia.vue').default)
Vue.component('none', require('@/components/none.vue').default)
Vue.component('alert', require('@/components/alert.vue').default)
Vue.component('alertImg', require('@/components/alertImg.vue').default)
Vue.component('VirtualKeyboard', require('@/components/VirtualKeyboard.vue').default)

// 引入 Vconsole
// import Vconsole from 'vconsole'

// 所有环境均使用
// new Vconsole()

Vue.use(ElementUI);

Vue.directive('removeAriaHidden', {
  bind(el, binding) {
    let ariaEls = el.querySelectorAll('.el-radio__original');
    ariaEls.forEach((item) => {
      item.removeAttribute('aria-hidden');
    });
  }
});

import 'amfe-flexible'


import { ding } from '@/utils/audio'
// import '@/utils/rem'
// Vue.prototype.handleSpeak = handleSpeak
Vue.prototype.ding = ding

import dispatchEventStroage from './utils/watchLocalStorage'
Vue.use(dispatchEventStroage);

import '@/assets/fonts/fonts.css'

// // 在页面刷新时，从本地存储中获取状态，并设置到Vuex中
// window.addEventListener('beforeunload', () => {
//   console.log('更新前', JSON.stringify(store.state));

//   localStorage.setItem('vuex-state', JSON.stringify(store.state));
// });

// // 在页面加载时，从本地存储中获取状态，并设置到Vuex中
// window.addEventListener('DOMContentLoaded', () => {
//   const savedState = JSON.parse(localStorage.getItem('vuex-state'));
//   localStorage.removeItem('vuex-state');
//   console.log("读取", savedState);

//   if (savedState) {
//     store.replaceState(savedState);
//     console.log("store", store);

//   }
// });

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app')
